var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M0 12.59v3.25h3.25l9.652-9.643-3.25-3.25zM15.75 3.788c0.164-0.165 0.266-0.393 0.266-0.644s-0.102-0.479-0.266-0.644l0 0-2.102-2.085c-0.165-0.161-0.391-0.261-0.64-0.261s-0.475 0.1-0.64 0.261l0-0-1.617 1.627 3.25 3.25c0.227 0.122 1.75-1.505 1.75-1.505z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }